import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">
          What Is VigorBuy Spreadsheet?
        </h2>
        <div className="text-foreground-600 leading-relaxed space-y-4 text-sm md:text-base">
          <p>
            <strong className="text-foreground-900">VigorBuy Spreadsheet</strong> is a structured product research resource that organizes popular products, categories, and shopping information into an easy-to-use format. Instead of spending hours searching across multiple sources, users can explore organized collections, compare products, review important details, and make smarter purchasing decisions.
          </p>
          <p>
            Our goal is to provide a simple and reliable <strong className="text-foreground-900">VigorBuy Spreadsheet</strong> knowledge platform for beginners and experienced shoppers. Whether you are looking for trending sneakers, seasonal jackets, or everyday accessories, the spreadsheet format helps you find relevant products quickly without the clutter and confusion of traditional browsing.
          </p>
          <p>
            Think of it as your personal shopping assistant — one that organizes everything neatly so you can focus on what matters: discovering products you actually want. With the <strong className="text-foreground-900">VigorBuy Spreadsheet</strong>, product research becomes straightforward, transparent, and genuinely enjoyable.
          </p>
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-primary-500 font-semibold text-sm hover:text-primary-600 transition-colors cursor-pointer"
          >
            Read the Full VigorBuy Spreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}